/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceWatchCancel = createReactComponent(
  "device-watch-cancel",
  "IconDeviceWatchCancel",
  [
    [
      "path",
      {
        d: "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 18v3h3", key: "svg-1" }],
    ["path", { d: "M9 6v-3h6v3", key: "svg-2" }],
    ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-3" }],
    ["path", { d: "M17 21l4 -4", key: "svg-4" }]
  ]
);

export { IconDeviceWatchCancel as default };
//# sourceMappingURL=IconDeviceWatchCancel.js.map
